export class DiganosisModel{
  patientcode = '' ;
  digdate = '2024-01-01' ;
  digtime = '2024-01-01' ;
  diglocation = '' ;
  cancerid = '' ;
  tissue = '' ;
  histology = '' ;
  grade = '' ;
  er = '' ;
  pdl1 = '' ;
  msi = '' ;
  egfr = '' ;
  alk = '' ;
  her2 = '' ;
  kras = '' ;
  braf = '' ;
  hrd = '' ;
  brca1 = '' ;
  brca2 = '' ;
  gscore = '' ;
  nfeature = '' ;
  pr = '' ;
  her2ihs = '' ;
  her2fish = '' ;
  ki67 = 0 ;
  ki67text = '';
  hpv = '' ;
  digsite = '' ;
  digstage = '' ;
  digt = '' ;
  dign = '' ;
  digm = '' ;
  digmain = '' ;
  dignotes = '' ;
  digdiganosisdate = '2024-01-01';
  userid = '';
  username = '';
  tissuehed = '' ;
histologyhed = '' ;
gradehed = '' ;
erhed = '' ;
pdl1hed = '' ;
msihed = '' ;
egfrhed = '' ;
alkhed = '' ;
her2hed = '' ;
krashed = '' ;
brafhed = '' ;
hrdhed = '' ;
brca1hed = '' ;
brca2hed = '' ;
gscorehed = '' ;
nfeaturehed = '' ;
prhed = '' ;
her2ihshed = '' ;
her2fishhed = '' ;
ki67hed = '' ;
hpvhed = '' ;
digsitehed = '' ;
digstagehed = '' ;
digthed = '' ;
dignhed = '' ;
digmhed = '' ;
canceridsub ='';
cancercode ='';
}
